var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.value.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, ("$1" + _vm.nl2br + "$2")), { disallowedTagsMode: 'escape' }))}})}
var staticRenderFns = []

export { render, staticRenderFns }